import { z } from "zod";

export const UserSchema = z.object({
  uid: z.string(),
  email: z.string().email(),
  displayName: z.string().optional(),
  photoURL: z.string().optional(),
  createdAt: z.any(), // Timestamp or string/Date depending on usage, keeping flexible for now
});

export type User = z.infer<typeof UserSchema>;
